import * as appConstant from '../../constants/appConstant'

const openModalDialogProvider = (openModal, closeModal, openAlert, closeAlert, modalConfiguration, getBearerToken, deSanitizeObject) => {
    return (modalType, rowData = {}) => {
        const isBulkUploadPopup = modalConfiguration[modalType]?.isBulkUploadPopup;
        let props = modalConfiguration[modalType].props;
        let deSanitizedRowData = deSanitizeObject(rowData);
        if (!isBulkUploadPopup) {
            getBearerToken();
            if (modalType === appConstant.PLACEMENT_MODE_DUPLICATE) {
                props.placementModalTitle = appConstant.DUPLICATE_RECORD_TITLE + deSanitizedRowData.id;
                props.placementRecord = {
                    ...deSanitizedRowData,
                    placementname: appConstant.COPY_OF + appConstant.SPACE + deSanitizedRowData.placementname,
                    status: appConstant.PROPOSED
                }
            }
        }
        const ModalContent = modalConfiguration[modalType].ModalContent;
        const modalProps = {
            closeModal: closeModal,
            openAlert: openAlert,
            closeAlert: closeAlert,
            placementRecord: deSanitizedRowData,
            ...props
        }
        openModal(<ModalContent {...modalProps}/>);
    }
}

export default openModalDialogProvider;